(function ($) {
    if (window.location.hash) {
        $('body').addClass('no-scroll');
        $('.c-popup').addClass('c-popup--open');
    }
})(jQuery);
